import React from "react"
import { IAccountDocument } from "../../../../models/documents/AccountDocument"
import strings from "../../../../localization/strings"
import Numeral from "numeral"
import TrendCompareGraph from "../../../../components/misc/TrendCompareGraph"

interface IProps {
    selectedAccount: IAccountDocument,
}

const AccountManagerClientTabClientDetailsBillingGraph: React.SFC<IProps> = (props: IProps) => {
    const accountStats = props.selectedAccount.AccountSettings.AccountStats

    return (
        props.selectedAccount.AccountSettings.CalculateBillingByDevice ?
        <div>
            <div style={{ width: "50%", float: "left", textAlign: "center" }}>
                <div className="graph-top-title">{strings.Active_Employee_Devices}</div>
                <div className="graph-top-title">
                    {accountStats && Numeral(accountStats.CurrentMonthTotalActiveEmployees).format("0,0") || 0}
                </div>
            </div>
            <div style={{ width: "50%", float: "left", textAlign: "center" }}>
                <div className="graph-top-title">{strings.Active_Clock_Devices}</div>
                <div className="graph-top-title">
                    {accountStats && Numeral(accountStats.CurrentMonthTotalActiveClocks).format("0,0") || 0}
                </div>
            </div>
            <TrendCompareGraph
                data1={accountStats.TotalActiveEmployeesPast12Months}
                data2={accountStats.TotalActiveClockDevicesPast12Months}
                label1={strings.Employees}
                label2={strings.Clocks}
            />
        </div> 
        :
        <div>
            <div style={{ width: "100%", float: "left", textAlign: "center" }}>
                <div className="graph-top-title">{strings.Active_Employees}</div>
                <div className="graph-top-title">
                    {accountStats && Numeral(accountStats.CurrentMonthTotalActiveEmployees).format("0,0") || 0}
                </div>
            </div>
            <TrendCompareGraph
                data1={accountStats.TotalActiveEmployeesPast12Months}
                label1={strings.Active}
            />
        </div>
    )
}

export default AccountManagerClientTabClientDetailsBillingGraph